import { getDatabase, onValue, query, ref } from "firebase/database";
import { useEffect, useState } from "react";
export default function useCashoutRequests(state) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [cashoutList, setCashoutList] = useState([]);
  useEffect(() => {
    async function fetchUsers() {
      //databse related works
      const db = getDatabase();
      const csahoutRef = ref(db, "CashoutRequest");
      const cashoutQuery = query(csahoutRef);

      try {
        setError(false);
        setLoading(true);
        //request firebase database;
        onValue(cashoutQuery, (snapshot) => {
          setLoading(false);
          if (snapshot.exists()) {
            setCashoutList((prevCashout) => {
              return [...Object.values(snapshot.val())];
            });
          }
        });
      } catch (err) {
        setLoading(false);
        setError(true);
      }
    }
    fetchUsers();
  }, [state]);

  return { loading, error, cashoutList };
}
